export default "__VITE_ASSET__loGzS7Al__"